module.exports = __webpack_public_path__ + "static/media/liushishishan1.563dc433.jpg";